const gadgetApi = new Gadget();


const checkBackinstock = async (productId, locationId, email, phone) => {
    const variables = {
        productId: productId.toString(),
        locationId: locationId.toString(),
        email: email.toString(),
        phone: phone.toString()
    };

};

async function subscribeToBackinstock(productId, locationId, email, phone, shopId) {
    const variables = {
        productId: productId != null ? String(productId) : undefined,
        locationId: locationId != null ? String(locationId) : undefined,
        email: email != null ? String(email) : undefined,
        phone: phone != null ? String(phone) : undefined,
        shopId: shopId != null ? String(shopId) : undefined
    };
    try {
        const result = await gadgetApi.subscribe(variables);
        return result;
    } catch (error) {
        console.error("Error subscribing to backinstock:", error);
        throw error;
    }
}